import { __assign, __awaiter, __generator, __rest } from "tslib";
import { enableHidingFinishedBills } from '../../../../lib/featbit';
import { searchMyBillList } from '../../bills.action';
import { orderBy, cloneDeep } from 'lodash';
var initValue = function () {
    var result = { bills: [], count: 0 };
    return result;
};
var loadMore = {
    type: 'loadMore'
};
var MyBillListData = (function () {
    function MyBillListData() {
        var _this = this;
        this.billTypes = orderBy([
            { type: 'rejected', weight: 1 },
            { type: 'draft', weight: 2 },
            { type: 'sending', weight: 3 },
            { type: 'receiving', weight: 4 },
            { type: 'receivingExcep', weight: 4 },
            { type: 'approving', weight: 5 },
            { type: 'pending', weight: 6 },
            { type: 'paying', weight: 7 },
            enableHidingFinishedBills() ? { type: 'paid', weight: 8 } : null,
        ].filter(Boolean), ['weight'], ['asc']);
        this.isLoading = false;
        this.requestParams = undefined;
        this.billListMap = cloneDeep(initValue());
        this.start = function (params, type) { return __awaiter(_this, void 0, void 0, function () {
            var p;
            return __generator(this, function (_a) {
                p = __assign({}, params);
                p.stateFilter = "state.in(" + type + ")";
                return [2, searchMyBillList(p)];
            });
        }); };
        this.isNeedGet = function (billInfo) {
            return billInfo.count === 0 || billInfo.bills.length < billInfo.count;
        };
        this.getBillList = function () {
            var result = [];
            result = result.concat(_this.billListMap.bills);
            if (_this.billListMap.bills.length < _this.billListMap.count) {
                result.push(loadMore);
            }
            return result;
        };
        this.init = function () {
            _this.billListMap = cloneDeep(initValue());
        };
        this.getBills = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var result, _a, isLoadMore, others;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.isLoading) return [3, 7];
                        result = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 6]);
                        return [4, this.getList(params)];
                    case 2:
                        result = _b.sent();
                        return [3, 6];
                    case 3:
                        if (!!!this.requestParams) return [3, 5];
                        _a = this.requestParams, isLoadMore = _a.isLoadMore, others = __rest(_a, ["isLoadMore"]);
                        if (!isLoadMore) {
                            this.init();
                        }
                        this.requestParams = undefined;
                        return [4, this.getList(__assign({}, others))];
                    case 4:
                        result = _b.sent();
                        _b.label = 5;
                    case 5: return [7];
                    case 6: return [2, result];
                    case 7:
                        this.requestParams = params;
                        return [2, []];
                }
            });
        }); };
        this.getList = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var billTypes, data, result, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.isLoading = true;
                        billTypes = this.billTypes;
                        if (!!((_a = params === null || params === void 0 ? void 0 : params.billTypes) === null || _a === void 0 ? void 0 : _a.length)) {
                            billTypes = billTypes.filter(function (el) { return params.billTypes.includes(el.type); });
                        }
                        params.start = this.billListMap.bills.length;
                        return [4, this.start(params, billTypes.map(function (item) { return "\"" + item.type + "\""; }).join(","))];
                    case 1:
                        data = _b.sent();
                        this.billListMap.count = data.count;
                        this.billListMap.bills = this.billListMap.bills.concat(data.items);
                        result = this.getBillList();
                        return [2, result];
                    case 2:
                        e_1 = _b.sent();
                        return [2, Promise.reject(e_1)];
                    case 3:
                        this.isLoading = false;
                        return [7];
                    case 4: return [2];
                }
            });
        }); };
    }
    return MyBillListData;
}());
export default MyBillListData;
